import { render } from "./OpenEdge.vue?vue&type=template&id=69721896&ts=true"
import script from "./OpenEdge.vue?vue&type=script&lang=ts&setup=true"
export * from "./OpenEdge.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/connect-flow/components/flow/nodes/OpenEdge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "69721896"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('69721896', __exports__)) {
    api.reload('69721896', __exports__)
  }
  
  module.hot.accept("./OpenEdge.vue?vue&type=template&id=69721896&ts=true", () => {
    api.rerender('69721896', render)
  })

}


export default __exports__